import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Home from './pages/HomePage';
import LandingPage from './pages/LandingPage';
import LocaleLayout from './i18n/LocaleLayout';
import { DEFAULT_LOCALE } from './i18n/routing';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/:lang" element={<LocaleLayout />}>
          {/* <Route index element={<Home />} />
          <Route path="home" element={<Home />} /> */}
        </Route>
        <Route path="*" element={<Navigate to={`/${DEFAULT_LOCALE}`} replace />} />
      </Routes>
    </Router>
  );
}

export default App;
